<template>
  <b-col cols="12" md="12" lg="6" sm="12" order="0" order-md="0">
    <div
      class="h6 text-justify rounded text-white px-4 py-3 bg-azul-medio w-100 mt-4"
    >
      <br />
      <div class="row">
        <div class="col-12">
          <p class="m-1 h5 mb-5">
            Si tu estudiante
            <strong>
              ingresará por primera vez al sistema escolar o necesita cambiarse
              de establecimiento para el año {{ anioAdmision }}</strong
            >, deberás postular entre el {{ inicioPostulacion }} y el
            {{ finPostulacion }}.
          </p>
          <br v-if="noTieneMiercoles" />
        </div>
      </div>

      <div class="h5 text-justify text-white bg-azul-medio w-100 mt-1">
        <ul class="m-1 h5 pl-0">
          <li class="font-weight-bold no-bullet h3 text-left mb-4">
            ¡IMPORTANTE ANTES DE POSTULAR!
          </li>

          <li>
            Postula solo si necesitas un nuevo establecimiento. Si tu estudiante
            es asignado en alguna de sus preferencias, perderá el cupo actual
            que utiliza.​
          </li>
          <li>
            Postula al menos 6 establecimientos y ordénalos según tus
            preferencias. Mientras más postulaciones ingreses, más posibilidades
            tienes de tener asignación.
          </li>
          <li>
            Verifica el curso al que estás postulando para el próximo año
            escolar.
          </li>
          <li>
            Tómate tu tiempo para postular. La asignación considera tus
            preferencias y los criterios de prioridad. No es por orden de
            llegada.
          </li>
        </ul>

        <!-- Texto centrado fuera de la lista -->
        <div class="w-100 text-center mt-5">
          Conoce todos los colegios disponibles a los que puedes postular.
        </div>
      </div>

      <div class="row mx-4 mx-lg-5 mt-4 mb-4">
        <router-link
          :to="{ name: 'Vitrina' }"
          class="btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100"
        >
          Ver Establecimientos
        </router-link>
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "InformacionPostulacion",
  data() {
    return {
      ayuda: PLATAFORMA.AYUDA,
      anioPostulacion: "",
      anioAdmision: "",
      inicioPostulacion: "",
      finPostulacion: ""
    };
  },
  created() {
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.anioPostulacion = obtenerValorLocalStorage("anioPostulacion");
    this.anioAdmision = obtenerValorLocalStorage("anioAdmision");
    this.inicioPostulacion = obtenerValorLocalStorage("inicioPostulacion");
    this.finPostulacion = obtenerValorLocalStorage("finPostulacion");
  },
  computed: {
    noTieneMiercoles() {
      return !(
        this.inicioPostulacion.includes("Miércoles") ||
        this.inicioPostulacion.includes("Miercoles") ||
        this.finPostulacion.includes("Miércoles") ||
        this.finPostulacion.includes("Miercoles")
      );
    }
  }
};
</script>

<style scoped>
.common-height {
  height: 100%; /* or a specific height like 500px */
}

.inicial {
  text-align: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/login/InformacionPostulacionRegistroAnticipado.vue